module.exports = __webpack_public_path__ + "img/post-image3.69601267.png";